export var ApiNotificationResourceType;
(function (ApiNotificationResourceType) {
    ApiNotificationResourceType["DashboardComments"] = "dashboardComments";
    ApiNotificationResourceType["AiReview"] = "aiReview";
    ApiNotificationResourceType["ContentReview"] = "contentReview";
    ApiNotificationResourceType["AiCreditAllowance"] = "aiCreditAllowance";
})(ApiNotificationResourceType || (ApiNotificationResourceType = {}));
//# sourceMappingURL=notifications.js.map